import { Link } from 'react-router-dom';

const quickLinks = [
  { label: '电影片库', to: '/movies' },
  { label: '最新资讯', to: '/news' },
  { label: '专题合集', to: '/specials' },
  { label: '关于我们', to: '/about' },
];

const genreLinks = ['动作', '科幻', '爱情', '喜剧', '剧情', '悬疑', '犯罪'];

export default function SiteFooter() {
  return (
    <footer className="border-t border-primary-500/20 bg-accent-100">
      <div className="shell py-12 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-play-fill text-2xl" aria-hidden="true"></i>
              </span>
              <div>
                <p className="font-heading text-xl font-bold tracking-[0.14em] text-foreground-950">午夜电影网</p>
                <p className="eyebrow mt-1 text-[10px] text-primary-500">Midnight Cinema</p>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-7 text-foreground-500">
              午夜电影网是一个以高清电影推荐与影视资讯为核心的观影门户。我们用策展的方式整理片单，用结构化的方式呈现信息，帮助你在无数选择里，找到今晚最想看的那个故事。
            </p>
            <p className="mt-4 text-xs leading-6 text-foreground-500/80">
              本站所有影片信息、评分、榜单纯属演示内容，播放功能为前端界面演示，不提供真实片源与下载。
            </p>
          </div>

          <div>
            <h2 className="eyebrow text-[11px] text-foreground-600">快速导航</h2>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-500">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="eyebrow text-[11px] text-foreground-600">热门类型</h2>
            <div className="mt-4 flex flex-wrap gap-2">
              {genreLinks.map((genre) => (
                <Link
                  key={genre}
                  to={`/movies?genre=${encodeURIComponent(genre)}`}
                  className="whitespace-nowrap rounded-full border border-secondary-600/40 px-3 py-1 text-xs text-foreground-600 transition-colors hover:border-primary-500/70 hover:text-primary-500"
                >
                  {genre}
                </Link>
              ))}
            </div>
            <h2 className="eyebrow mt-7 text-[11px] text-foreground-600">友情链接</h2>
            <div className="mt-4 flex flex-wrap gap-x-4 gap-y-2 text-xs text-foreground-500">
              <span>光影资料馆</span>
              <span>独立影展观察</span>
              <span>深夜放映室</span>
              <span>电影声音研究所</span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-600/30 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 午夜电影网 Midnight Cinema. 保留所有权利。</p>
          <p>本站为演示站点 · 不提供真实影视资源 · 内容仅供学习交流</p>
        </div>
      </div>
    </footer>
  );
}